module.exports = __webpack_public_path__ + "media/8.dae7bcc5.mp4";